import * as React from 'react';
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  IconButton,
  Paper,
  CircularProgress,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { getUserTemplateGenerationsById } from '../../utils/templatesApi';

dayjs.extend(relativeTime);

export default function Users({ Options, loading,value }) {
  const getLastLoginText = (dateString) => {
    if (!dateString) return 'Never logged in';

    const lastLogin = dayjs(dateString);
    const now = dayjs();

    const diffInMinutes = now.diff(lastLogin, 'minute');

    return diffInMinutes <= 5 ? 'Online' : lastLogin.fromNow();
  };

  function Row({ user }) {
    const [open, setOpen] = React.useState(false);
    const [details, setDetails] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const handleToggle = async () => {
      const nextOpen = !open;
      setOpen(nextOpen);
         const filters = {
            startDate: value?.[0] ? dayjs(value[0]).toISOString() : undefined,
            endDate: value?.[1] ? dayjs(value[1]).toISOString() : undefined,
          };

      if (nextOpen && details.length === 0) {
        setLoading(true);
        try {
          const result = await getUserTemplateGenerationsById(user?.userId,filters);
          console.log('result: ', result[0].generatedCount);
          setDetails(result|| []);
        } catch (err) {
          console.error('Error fetching details for user:', user?.userId, err);
        } finally {
          setLoading(false);
        }
      }
    };

    return (
      <>
        <TableRow>
          <TableCell>
            <IconButton onClick={handleToggle} size="small">
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {user?.['user.first_name']} {user?.['user.last_name']}
          </TableCell>
          <TableCell align="right">{user?.generatedCount}</TableCell>
          <TableCell align="right">
            {getLastLoginText(user?.['user.lastLogin'])}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                {loading ? (
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    <CircularProgress size={24} />
                  </Box>
                ) : (
                  <Table size="small" aria-label="user-details">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Template Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Category Name
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                          Generated Count
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                          Possible Templates
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {details?.map((template) => (
                        <TableRow key={template?.['template.id']}>
                          <TableCell>{template?.['template.name']}</TableCell>
                          <TableCell>{template?.["template.category.category_name"]}</TableCell>
                          <TableCell align="right">
                            {template?.generatedCount}
                          </TableCell>
                          <TableCell align="right">
                            {template?.['template.possibleTemplates']}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '75vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ minWidth: '80vw', maxHeight: '75vh', overflow: 'auto' }}
        >
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow
                sx={{ position: 'sticky', top: 0, backgroundColor: '#fff' }}
              >
                <TableCell />
                <TableCell sx={{ fontWeight: 'bold' }}>User Name</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                  Total Count
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                  Last Active
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Options?.map((user, index) => (
                <Row key={index} user={user} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
